import { StyleSheet } from 'aphrodite'
import main from './main'
import table from './table'
import headers from './headers'
import paragraphs from './paragraphs'

export default {
  main: StyleSheet.create(main),
  table: StyleSheet.create(table),
  headers: StyleSheet.create(headers),
  paragraphs: StyleSheet.create(paragraphs)
}



// WEBPACK FOOTER //
// ./src/components/Rates/style/index.js